import type { RecommendationResult } from "../types";

export const combineDurationRecommendationResults = ({
	examId,
	results,
}: {
	examId: string;
	results: RecommendationResult[];
}): RecommendationResult => {
	const sessions = results.flatMap((result, index) => {
		if (result.status !== "READY" || result.sessions.length === 0) {
			return [];
		}
		return [
			{ ...(result.sessions[index] ?? result.sessions[0]), rank: index + 1 },
		];
	});
	if (sessions.length > 0) {
		return { status: "READY", examId, sessions };
	}
	const unavailable = results.find(
		(
			result,
		): result is Extract<RecommendationResult, { status: "UNAVAILABLE" }> =>
			result.status === "UNAVAILABLE",
	);
	return {
		status: "UNAVAILABLE",
		examId,
		reason: unavailable?.reason ?? "NO_AVAILABLE_ITEMS",
		sessions: [],
	};
};

export const resolveQuickStudyRecommendationSessions = <
	TStudyRecommendation,
	TFallback,
>({
	studyRecommendationEnabled,
	studyRecommendationLoading,
	studyRecommendationSessions,
	fallbackSessions,
}: {
	studyRecommendationEnabled: boolean;
	studyRecommendationLoading: boolean;
	studyRecommendationSessions: TStudyRecommendation[];
	fallbackSessions: TFallback[];
}): Array<TStudyRecommendation | TFallback> => {
	if (studyRecommendationEnabled) {
		if (studyRecommendationLoading) {
			return [];
		}
		if (studyRecommendationSessions.length > 0) {
			return studyRecommendationSessions;
		}
	}
	return fallbackSessions;
};
